import categoriesApi from '../../api/categories';

const state = {
  categories: []
};

const getters = {
  categories: state => state.categories
};

const mutations = {
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
  },
  
  ADD_CATEGORY(state, category) {
    state.categories.push(category);
  },
  
  UPDATE_CATEGORY(state, updatedCategory) {
    const index = state.categories.findIndex(c => c.id === updatedCategory.id);
    if (index !== -1) {
      state.categories.splice(index, 1, updatedCategory);
    }
  },
  
  DELETE_CATEGORY(state, categoryId) {
    state.categories = state.categories.filter(c => c.id !== categoryId);
  },
  
  ADD_SUBCATEGORY(state, { categoryId, subcategory }) {
    const category = state.categories.find(c => c.id === categoryId);
    if (category) {
      if (!category.subcategories) {
        category.subcategories = [];
      }
      category.subcategories.push(subcategory);
    }
  },
  
  UPDATE_SUBCATEGORY(state, { categoryId, subcategory }) {
    const category = state.categories.find(c => c.id === categoryId);
    if (category) {
      const index = category.subcategories.findIndex(s => s.id === subcategory.id);
      if (index !== -1) {
        category.subcategories.splice(index, 1, subcategory);
      }
    }
  },
  
  DELETE_SUBCATEGORY(state, { categoryId, subcategoryId }) {
    const category = state.categories.find(c => c.id === categoryId);
    if (category) {
      category.subcategories = category.subcategories.filter(s => s.id !== subcategoryId);
    }
  }
};

const actions = {
  async fetchCategories({ commit, rootState }) {
    try {
      const { apptoken } = rootState.appauth;
      const response = await categoriesApi.fetchCategories(apptoken);
      commit('SET_CATEGORIES', response.data.categories);
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },
  
  async createCategory({ commit, rootState }, category) {
    try {
      const { apptoken } = rootState.appauth;
      const response = await categoriesApi.createCategory(apptoken, category);
      commit('ADD_CATEGORY', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  },
  
  async updateCategory({ commit, rootState }, category) {
    try {
      const { apptoken } = rootState.appauth;
      const response = await categoriesApi.updateCategory(apptoken, category.id, category);
      commit('UPDATE_CATEGORY', response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating category:', error);
      throw error;
    }
  },
  
  async deleteCategory({ commit, rootState }, categoryId) {
    try {
      const { apptoken } = rootState.appauth;
      await categoriesApi.deleteCategory(apptoken, categoryId);
      commit('DELETE_CATEGORY', categoryId);
    } catch (error) {
      console.error('Error deleting category:', error);
      throw error;
    }
  },
  
  async createSubcategory({ commit, rootState }, { categoryId, subcategory }) {
    try {
      const { apptoken } = rootState.appauth;
      const response = await categoriesApi.createSubcategory(apptoken, categoryId, subcategory);
      commit('ADD_SUBCATEGORY', { categoryId, subcategory: response.data });
      return response.data;
    } catch (error) {
      console.error('Error creating subcategory:', error);
      throw error;
    }
  },
  
  async updateSubcategory({ commit, rootState }, { categoryId, subcategory }) {
    try {
      const { apptoken } = rootState.appauth;
      const response = await categoriesApi.updateSubcategory(
        apptoken,
        categoryId,
        subcategory.id,
        subcategory
      );
      commit('UPDATE_SUBCATEGORY', { categoryId, subcategory: response.data });
      return response.data;
    } catch (error) {
      console.error('Error updating subcategory:', error);
      throw error;
    }
  },
  
  async deleteSubcategory({ commit, rootState }, { categoryId, subcategoryId }) {
    try {
      const { apptoken } = rootState.appauth;
      await categoriesApi.deleteSubcategory(apptoken, categoryId, subcategoryId);
      commit('DELETE_SUBCATEGORY', { categoryId, subcategoryId });
    } catch (error) {
      console.error('Error deleting subcategory:', error);
      throw error;
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}; 